import React, { useState } from 'react'
import { Checkbox } from "antd"

import Modal from "../reusable/modal"

import { usePet, useToggle } from '../../modules'
import pluralize from 'pluralize'

const EditOrderItem = ({ toggle, visible, item, onPerform }) => {
    const [quantity, setQuantity] = useState(item.quantity)
    const [instructions, setInstructions] = useState(item.instructions)

    const [{ loading }, editOrderItem] = usePet('editOrderItem', { 
        id: item?._id,
        quantity,
        instructions
    }, { notify: true, callback: (_, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        onPerform()
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Saving changes...' } })

    const modifyQty = val => {
        if (val > 0)
            setQuantity(val)
    }

    return (
        <Modal
            w={ 400 }
            title="Edit Item"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <div className="p-2 flex items-center justify-center">
                        <button onClick={() => modifyQty(quantity - 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">-</button>
                        <span className="text-center px-3">{ quantity }</span>
                        <button onClick={() => modifyQty(quantity + 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">+</button>
                    </div>
                </div>
                <div className="w-full my-2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Instructions
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-instructions"
                        rows="5"
                        name="instructions"
                        value={ instructions }
                        onChange={ e => setInstructions(e.target.value) }
                        placeholder="Instructions" />
                </div>
            </div>
            <div className="flex justify-end mt-3">
                <button disabled={ loading } onClick={ editOrderItem } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default EditOrderItem